import { GRADUATION_NAME } from '@/domain/image/graduationName';
import type { IImageBehavior } from '@/domain/image/IImageBehavior';

// Migration shim — legacy templates were serialized with the
// discriminator `filename === 'GRADUATION'` and no `behavior` field.
// fromJSON calls this to synthesise the equivalent behavior on load so
// existing DB / localStorage payloads keep working. New fields carry
// `behavior` explicitly and never hit this path.
const LEGACY_GRADUATION_BEHAVIOR: IImageBehavior = {
    alwaysOnTop: true,
    constrainToFrameX: true,
    fitToFrameHeight: true,
    hideControls: true,
    lockY: true,
};

function graduationBehaviorFallback(filename: string | undefined): IImageBehavior | undefined {
    return filename === GRADUATION_NAME ? { ...LEGACY_GRADUATION_BEHAVIOR } : undefined;
}

export { graduationBehaviorFallback, LEGACY_GRADUATION_BEHAVIOR };
